import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "../../common/Sidebar";
import { useDispatch } from "react-redux";
import { createTextToImageThunk, fetchTextToImageThunk } from "../../apps/textToImageSlice";
import { useFormik } from "formik";
import { textToImageSchema } from "../../validations";

const TattooGenerator = ({ onHide }) => {
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const config = {
    authorization: "Bearer MjgwO36T$&l6^F%^*M7zU!@$858tN&*$%TBF%^5Q6i0*#$03R7^%$#@!T346gxLTh86F8Nk44It44^&#$5OUR7G%^#$&MzD"
  };

  // useFormik hook outside of return statement
  const formik = useFormik({
    initialValues: {
      prompt: "",
      aspect_ratio: "1:1",  // default value
      uuid: ""  // default value
    },
    validationSchema: textToImageSchema,
    onSubmit: async (values) => {
      setLoading(true);

      // Dispatching the request to generate the tattoo (replace with actual API call)
      const response = await dispatch(createTextToImageThunk({ config, values }));
      setImage(response?.payload?.data?.imageUrl)
      await dispatch(fetchTextToImageThunk())
      // onHide()
      // Simulating image generation (replace this with actual API response handling)
      // setTimeout(() => {
      //   setImage(`https://via.placeholder.com/400x200.png?prompt=${encodeURIComponent(prompt)}`);
      //   setLoading(false);
      // }, 2000);
    }
  });

  return (
    <>
      <Sidebar />
      <div className="container py-5">
        <div className="card shadow-lg p-4" style={{ maxWidth: "600px", margin: "auto", borderRadius: "15px" }}>
          <h2 className="prompt-center mb-4 prompt-primary fw-bold">Tattoo Generator</h2>

          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                name="prompt"
                className="form-control form-control-lg border-primary"
                placeholder="Enter prompt for tattoo"
                value={formik.values.prompt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
                {formik.touched.prompt && formik.errors.prompt ? (
              <span style={{ color: "red" }}>
                  <div>{formik.errors.prompt}</div>
              </span>
                ) : null}
            </div>

            <div className="mb-3">
              <input
                type="text"
                name="aspect_ratio"
                className="form-control form-control-lg border-primary"
                placeholder="Enter aspect ratio"
                value={formik.values.aspect_ratio}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
                {formik.touched.aspect_ratio && formik.errors.aspect_ratio ? (
              <span style={{ color: "red" }}>
                  <div>{formik.errors.aspect_ratio}</div>
              </span>
                ) : null}
            </div>

            <div className="mb-3">
              <input
                type="text"
                name="uuid"
                className="form-control form-control-lg border-primary"
                placeholder="Enter UUID"
                value={formik.values.uuid}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
                {formik.touched.uuid && formik.errors.uuid ? (
              <span style={{ color: "red" }}>
                  <div>{formik.errors.uuid}</div>
              </span>
                ) : null}
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 fw-bold py-2 shadow"
            // disabled={formik.isSubmitting || loading}
            >
              {loading ? "Generating..." : "Generate Tattoo"}
            </button>
          </form>

          {image && (
            <div className="mt-4 prompt-center">
              <h5 className="prompt-success">Generated Tattoo</h5>
              <img src={image} alt="Generated Tattoo" className="img-fluid rounded shadow" style={{ maxWidth: "100%" }} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TattooGenerator;
